import { TranslateService } from '@ngx-translate/core';
import { Alert, EventAlertEntity, PriorityConfig } from '../../models/alert';
import { EventAlertViewModel } from './event-alert.view-model';

export class EventNoShowAlertViewModel extends EventAlertViewModel {
  constructor(
    alert: Alert<EventAlertEntity>,
    translateService: TranslateService,
    priorityConfig: PriorityConfig | null = null,
  ) {
    super(alert, translateService, priorityConfig);
  }

  get title(): string {
    return this.translateService.instant('Missing organizer: Someone is waiting');
  }

  override get expiryDate(): Date | null {
    return this.entity?.end_time ?? null;
  }

  override get alertTypeLabel(): string {
    return this.translateService.instant('Missing organizer');
  }
}
